import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import './ContactUs.css';
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';

const ContactForm = () => {
    const location = useLocation();
    const formRef = useRef(null);
    const form = useRef();
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("");
    const [phone, setPhone] = useState("");

    const handleCaptcha = (value) => {
        setCaptchaVerified(!!value);
    };

    const sendEmail = (e) => {
        e.preventDefault();
        if (!captchaVerified) {
            setPopupMessage("❌ Please verify reCAPTCHA.");
            setPopupType("error");
            setTimeout(() => setPopupMessage(""), 4000);
            return;
        }

        emailjs.sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
            form.current,
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        ).then(
            () => {
                setPopupMessage("✅ Message sent successfully!");
                setPopupType("success");
                e.target.reset();
                setPhone("");
                setCaptchaVerified(false);
                setTimeout(() => setPopupMessage(""), 4000);
            },
            () => {
                setPopupMessage("❌ Failed to send message. Please try again.");
                setPopupType("error");
                setTimeout(() => setPopupMessage(""), 4000);
            }
        );
    };

    // ✅ Scroll to form if state passed
    useEffect(() => {
        if (location.state?.scrollTo === "form" && formRef.current) {
            setTimeout(() => {
                formRef.current.scrollIntoView({ behavior: "smooth" });
            }, 300);
        }
    }, [location]);

    return (
        <>




         <Helmet>
        <title>Contact Us APTech Solution - Web & App Development</title>
        <meta
          name="description"
          content="Get in touch with APTech Solution for web, app, software development, and digital marketing services in Ankleshwar, Gujarat."
        />
      </Helmet>
            <div className='fullcolordiv2'>
                <h1 className='aboutpageheading'>Ready to Work With Us?</h1>
                <p className='aboutpageparagraph'>Get in touch with our team for inquiries, support, or to request a quote.</p>
            </div>

            <div className="contact-cards">
                {/* Cards */}
                <div className="card">
                    <div className="card-header">
                        <div className="iconcontactus"><FaPhoneAlt /></div>
                        <h3>Call Us</h3>
                    </div>
                    <p><strong>Sales & Support:</strong><br />+91 8490957541</p>
                    {/* <p><strong>Technical Support:</strong><br />+91 8490957541</p> */}
                </div>
                <div className="card">
                    <div className="card-header">
                        <div className="iconcontactus"><FaEnvelope /></div>
                        <h3>Email Us</h3>
                    </div>
                    <p><strong>General Inquiries:</strong><br />info@aptechsolution.com</p>
                    
                </div>
                <div className="card">
                    <div className="card-header">
                        <div className="iconcontactus"><FaClock /></div>
                        <h3>Working Hours</h3>
                    </div>
                    <p><strong>Monday to Friday:</strong><br />9:00 AM - 6:00 PM</p>
                    <p><strong>Saturday:</strong><br />9:00 AM - 2:00 PM</p>
                </div>
            </div>

            <div id="contact-section" ref={formRef} style={{ scrollMarginTop: '100px' }}>
                <div className="contact-map-wrapper">
                    {/* Form Section */}
                    <div className="form-section">
                        <div className="contactUsHeading">
                            <h1>Send Us a Message</h1>
                            <p>Fill out the form below and our team will get back to you as soon as possible.</p>
                        </div>
                        <form ref={form} onSubmit={sendEmail} className="formPopup">
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Your Name *</label>
                                    <input type="text" name="first_name" required placeholder="John Doe" />
                                </div>
                                <div className="form-group">
                                    <label>Email Address *</label>
                                    <input type="email" name="user_email" required placeholder="john@example.com" />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Phone Number *</label>
                                    <PhoneInput
                                        country={'in'}
                                        value={phone}
                                        onChange={setPhone}
                                        enableSearch={true}
                                        inputProps={{ name: 'mobile', required: true }}
                                    />
                                    <input type="hidden" name="mobile" value={phone} />
                                </div>
                                <div className="form-group">
                                    <label>Company Name</label>
                                    <input type="text" name="company" placeholder="Your Company Ltd." />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group full-width">
                                    <label>Address</label>
                                    <input type="text" name="address" placeholder="Enter your address" />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group full-width">
                                    <label>Subject</label>
                                    <input type="text" name="subject" placeholder="How can we help you?" />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group full-width">
                                    <label>Your Message *</label>
                                    <textarea name="message" required placeholder="Please provide details about your inquiry..."></textarea>
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group full-width">
                                    <ReCAPTCHA
                                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                        onChange={handleCaptcha}
                                    />
                                </div>
                            </div>

                            <button className="button" type="submit">Send Message</button>
                        </form>
                    </div>

                    {/* Map Section */}
                    <div className="map-section">
                        <div className="contactUsHeading">
                            <h1>Our Location</h1>
                            <p>Visit our office or find us easily on the map below.</p>
                        </div>
                        <div className="map-container">
                            <iframe
                                title="Company Location"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2825.036150429187!2d73.0133316!3d21.6340632!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be0234af8b60ba1%3A0xb287b241582b2e0e!2sA.P%20Tech%20Solution!5e1!3m2!1sen!2sin!4v1758087359894!5m2!1sen!2sin"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>

            {popupMessage && (
                <div className={`popup ${popupType}`}>
                    {popupMessage}
                </div>
            )}
        </>
    );
};

export default ContactForm;
